let service = function (Http) {
	"ngInject";

	this.get = (metric, scope) => Http.get('/v1/dashboard/leaderboard', false, {
		metric: metric,
		scope: scope
	});

};

export default service;


// WEBPACK FOOTER //
// ./app/components/leaderboard/leaderboard.service.js